import { render, staticRenderFns } from "./platformLanguages.vue?vue&type=template&id=6a1fdcc4&"
import script from "./platformLanguages.vue?vue&type=script&lang=js&"
export * from "./platformLanguages.vue?vue&type=script&lang=js&"
import style0 from "./platformLanguages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports